// Components
import { LegalPageContent } from '../../components/LegalPageContent/LegalPageContent';

export const DataProcessingAddendumPage = () => {
  return <LegalPageContent slug="data-processing-addendum" fallbackTitle="Data Processing Addendum" />;
};
